import { BaseError } from '../BaseError';

export const NotFound = ({ message }: { message: string }) => {
  return <BaseError title={'Not Found'} paragraphs={[message]} />;
};
